import { CheckOutlined, CloseOutlined, LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Button, Form, Input, Modal } from "antd";
import axios from "axios";
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

const backend = process.env.REACT_APP_BACKEND

function UpdateModal ({stateHandler, updateModal, tableParmas}) {
  const navigate = useNavigate()
  
  const formRef = useRef()
  const pageChangeRef = useRef(false)

  const updateHandler = async() => {
    const value = await formRef.current.validateFields();

    axios
      .patch(`${backend}/contents/new_word/prompt/list/${value.id}`, { value })
      .then((data) => {
        stateHandler("reRender")
        Modal.success({
          title: "수정 완료",
          okText: "확인",
          content: "정상적으로 수정되었습니다.",
        });
      })
      .catch((err) => {
        if (err.response.status === 401) {
          navigate("/auth");
        } else {
          console.log(err);
          Modal.error({
            title: "등록 실패",
            style: { whiteSpace: "pre-line" },
            okText: "확인",
            content:err.response.data.message ||
              "정상적으로 등록되지 않았습니다. \n다시 시도하거나 관리자에게 문의해주세요.",
          });
        }
      });
  }

  const cancelHandler = () => {
    stateHandler("updateModal",[false,{}])
    stateHandler("rowIndex", null)
  }

  const preRecordHandler = () => {
    const {current, pageSize, total} = tableParmas.pagination
    const newRowIndex = updateModal[1].indexNumber -1

    if(current === 1) {
      if(newRowIndex >= 0) {
        stateHandler("rowIndex", newRowIndex)
        stateHandler("preNext", newRowIndex)
      }
    } else {
      if(newRowIndex < 0) {
        stateHandler("tableParams", {
          ...tableParmas,
          pagination: {
            ...tableParmas.pagination,
            current: current -1
          }
        })
        stateHandler("rowIndex", pageSize -1)
        // 페이지가 바뀌는 상황에서 preNext를 하게되면 이전데이터로 리셋되었다가 다시 신규데이터로 리셋되기 때문에 깜빡임이 발생한다.
      } else {
        stateHandler("rowIndex", newRowIndex)
        stateHandler("preNext", newRowIndex)
      }
    }
  }

  const nextRecordHandler = () => {
    const {current, pageSize, total} = tableParmas.pagination
    const newRowIndex = updateModal[1].indexNumber +1
    const maxPage = total%pageSize === 0 ? total/pageSize : parseInt(total/pageSize) +1
    const maxPageRow = total%pageSize
    if(current === maxPage) {
      if(newRowIndex < maxPageRow) {
        stateHandler("rowIndex", newRowIndex)
        stateHandler("preNext", newRowIndex)
      }
    } else {
      if(newRowIndex >= pageSize) {
        stateHandler("tableParams", {
          ...tableParmas,
          pagination: {
            ...tableParmas.pagination,
            current: current +1
          }
        })
        stateHandler("rowIndex", 0)
        // 페이지가 바뀌는 상황에서 preNext를 하게되면 이전데이터로 리셋되었다가 다시 신규데이터로 리셋되기 때문에 깜빡임이 발생한다.
      } else {
        stateHandler("rowIndex", newRowIndex)
        stateHandler("preNext", newRowIndex)
      }
    }
  }

  useEffect(()=>{
    if(formRef.current) {
      formRef.current.resetFields()
    }
  },[JSON.stringify(updateModal[1])])

  return (
    <Modal
      destroyOnClose={true}
      open={updateModal[0]}
      title="프롬프트 수정"
      maskClosable={false}
      onCancel={() => stateHandler("updateModal",[false,{}])}
      footer={
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            onClick={() => {
              formRef.current.resetFields();
            }}
          >
            내용 초기화
          </Button>
          <span>
            <Button
              onClick={preRecordHandler}
              icon={<LeftOutlined/>}
            >이전
            </Button>
            <Button
              type="primary"
              onClick={updateHandler}
              icon={<CheckOutlined />}
            >
              수정
            </Button>
            <Button
              onClick={nextRecordHandler}
              icon={<RightOutlined />}
            >다음</Button>
            <Button
              onClick={cancelHandler}
              icon={<CloseOutlined />}
            >
              취소
            </Button>
          </span>
        </div>
      }
    >
      <Form
        ref={formRef}
        layout="vertical"
        initialValues={updateModal[1]}
      >
        <Form.Item
          name="id"
          label="아이디"
          hidden
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="prompt_name"
          label="명칭"
          required={true}
          rules={[{ required: true, message: "명칭은 필수값입니다." }]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default UpdateModal